var _path, _path2, _line;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDrag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 46,
    viewBox: "0 0 32 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0052 43.3307H20.0052C26.6719 43.3307 29.3385 40.6641 29.3385 33.9974V25.9974C29.3385 19.3307 26.6719 16.6641 20.0052 16.6641H12.0052C5.33854 16.6641 2.67188 19.3307 2.67188 25.9974V33.9974C2.67188 40.6641 5.33854 43.3307 12.0052 43.3307Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.77344 33.3197L12.9468 29.1997C13.4001 28.613 14.2401 28.5064 14.8268 28.9597L17.2668 30.8797C17.8534 31.333 18.6934 31.2264 19.1468 30.653L22.2268 26.6797",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 4.37091e-8,
    x2: 16,
    y2: 16,
    stroke: "white",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrag);
export default __webpack_public_path__ + "static/media/drag.3e170e3a9872d5ff2b3539a4a254a6e6.svg";
export { ForwardRef as ReactComponent };